<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      d="M21 10.6964V19.4799C21 19.883 20.8419 20.2697 20.5606 20.5548C20.2793 20.8398 19.8978 21 19.5 21H15.75C15.3522 21 14.9706 20.8398 14.6893 20.5548C14.408 20.2697 14.25 19.883 14.25 19.4799V15.6795C14.25 15.478 14.171 15.2846 14.0303 15.1421C13.8897 14.9996 13.6989 14.9195 13.5 14.9195H10.5C10.3011 14.9195 10.1103 14.9996 9.96966 15.1421C9.82901 15.2846 9.74999 15.478 9.74999 15.6795V19.4799C9.74999 19.883 9.59196 20.2697 9.31065 20.5548C9.02935 20.8398 8.64782 21 8.24999 21H4.5C4.10217 21 3.72064 20.8398 3.43934 20.5548C3.15804 20.2697 3 19.883 3 19.4799V10.6964C2.99997 10.486 3.04303 10.2779 3.12646 10.0852C3.20989 9.89259 3.33187 9.71958 3.48469 9.57718L10.9847 2.40597L10.995 2.39552C11.2711 2.14102 11.631 2 12.0042 2C12.3775 2 12.7373 2.14102 13.0134 2.39552C13.0166 2.39924 13.0201 2.40273 13.0237 2.40597L20.5237 9.57718C20.675 9.72034 20.7954 9.89367 20.8774 10.0863C20.9593 10.2789 21.0011 10.4866 21 10.6964Z"
    />
  </svg>
</template>
